import { useEffect } from "react"
import BannerComponent from "../components/base/bannerComponent"
import Container from "../components/base/container"
import PageLayout from "../components/base/page-layout"
import { homePage } from "../components/filters/home-filters.module.scss"
import HomeScreen from "../components/home/home-screen"
import { buySlug } from "../utils/constants"
import { checkUA, getHomeLinks, recordPageView } from "../utils/utility"

export default function BuyLanding(props) {
  const { isMobile, allLinks } = props

  useEffect(() => {
    recordPageView("/rent.html")
  }, [])

  return (
    <>
      <PageLayout
        className={homePage}
        pageTitle="Rent and Buy Properties in Pakistan"
        description={
          "Browse property on Lamudi.pk the best real estate and property website in Pakistan. Search houses, plots, new projects, commercial plots, villas, flats, ready to move apartments for rent and sale in Karachi Lahore Islamabad and all over Pakistan."
        }
        headTitle="Lamudi.pk"
        bannerComponent={<BannerComponent isMobile={isMobile} purpose={buySlug} />}
        bannerComponentPlacement="left"
      >
        <Container>
          <HomeScreen allLinks={allLinks} purpose={buySlug} />
        </Container>
      </PageLayout>
    </>
  )
}

export async function getServerSideProps(ctx) {
  let isMobile = checkUA(ctx.req.headers["user-agent"])

  let links = await getHomeLinks(2)

  return {
    props: {
      isMobile,
      allLinks: links,
    },
  }
}
